import { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Routes } from '../../../app/routes';
import useMenuItems from '../../../layouts/main/hooks/use-menu-items';
import { useAppSelector } from '../../../store/hooks';
import { store } from '../../../store/store';
import { selectIsAuthenticated, selectPrefilledDomain } from '../../auth/store/auth-slice';

const Main = (): JSX.Element => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const [menuItems] = useMenuItems();
  const navigate = useNavigate();
  const [domain] = useState<string | null>(selectPrefilledDomain(store.getState()));

  useEffect(() => {
    if (isAuthenticated && menuItems.length) {
      const mainMenuItem = menuItems.find(menuItem => menuItem.path === Routes.SignRequests) || menuItems[0];
      navigate(mainMenuItem.path);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, menuItems]);

  return !isAuthenticated ? <Navigate to={domain ? `${Routes.Login}?domain=${domain}` : Routes.Login} /> : <></>;
};

export default Main;
